import React from 'react';
import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcon';
import Label from '../Label';
import Markdown from '../Markdown';
import Span from '../Span';
import TextArea from '../TextArea';

const SPAN_DEFAULT = '';
const MARGIN_TOP_CLASS = 'mt-5';

const TextAreaRenderer = ({ item, errors, fieldsValidated }) => (
  <div className={`col-lg-12 ${MARGIN_TOP_CLASS}`}>
    <div className="form-group">
      <Label
        label={item.label}
        name={item.name}
        errors={errors}
        required={item.required}
      />

      <CustomIcon
        fieldsValidated={fieldsValidated}
        fieldError={errors[item.name]}
        required={item.required}
      />

      <Markdown
        lassName="col-xl-12 col-lg-12 mt-3"
        text={item.description}
      />

      <TextArea
        name={item.name}
        numberOfWords={item.wordLimit !== null ? item.wordLimit : undefined}
        numberOfRows={8}
        placeholder={item.placeholder}
      />

      <Span
        text={errors[item.name] ? errors[item.name].message : SPAN_DEFAULT}
      />
    </div>
  </div>
);

TextAreaRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  fieldsValidated: PropTypes.bool,
};

export default TextAreaRenderer;
